import { InventoryItem } from "@1games-ru/region-shared/dist/types/inventory/inventory";

function positionsOverlap(
  posA: InventoryItem["position"],
  sizeA: InventoryItem["size"],
  posB: InventoryItem["position"],
  sizeB: InventoryItem["size"],
): boolean {
  return !(
    posA.x + sizeA.width <= posB.x ||
    posB.x + sizeB.width <= posA.x ||
    posA.y + sizeA.height <= posB.y ||
    posB.y + sizeB.height <= posA.y
  );
}

function canPlaceAt(
  position: InventoryItem["position"],
  size: InventoryItem["size"],
  placedItems: InventoryItem[],
  gridWidth: number,
  gridHeight: number,
): boolean {
  // Проверка на выход за границы
  if (
    position.x < 0 ||
    position.y < 0 ||
    position.x + size.width > gridWidth ||
    position.y + size.height > gridHeight
  ) {
    return false;
  }

  // Проверка на пересечение с уже размещёнными предметами
  for (const item of placedItems) {
    if (!item.position) continue;
    if (positionsOverlap(position, size, item.position, item.size)) {
      return false;
    }
  }

  return true;
}
/**
 * Размещает предметы в сетке шириной gridWidth и высотой gridHeight.
 * Предметы, у которых уже есть position, сохраняются на месте.
 * Для остальных ищется первая доступная позиция.
 */
export function placeItemsWithMemo(
  items: InventoryItem[],
  gridWidth: number,
  gridHeight: number,
): InventoryItem[] {
  const placedItems: InventoryItem[] = [];

  for (const item of items) {
    // Проверяем, есть ли у этого item уже позиция в placedItems (по id)
    const alreadyPlaced = placedItems.find((pi) => pi.id === item.id);

    if (alreadyPlaced && alreadyPlaced.position) {
      // Если позиция уже есть — оставляем как есть
      continue;
    }

    // Если позиции нет, или предмет не найден в placedItems — ищем новую позицию
    let placed = false;

    for (let y = 0; y <= gridHeight - item.size.height && !placed; y++) {
      for (let x = 0; x <= gridWidth - item.size.width && !placed; x++) {
        const position: InventoryItem["position"] = { x, y };

        if (canPlaceAt(position, item.size, placedItems, gridWidth, gridHeight)) {
          // Если предмет уже есть в placedItems (без позиции), обновляем
          if (alreadyPlaced) {
            alreadyPlaced.position = position;
          } else {
            // Если предмет новый, добавляем с позицией
            placedItems.push({ ...item, position });
          }
          placed = true;
        }
      }
    }

    if (!placed) {
      throw new Error(`Не удалось разместить предмет ${item.id}`);
    }
  }

  return placedItems;
}
